/**
 * The founders widget bubble's tail: a curved hook growing out of the
 * bubble's bottom-right corner toward the avatar. A chunky lobe, 14px of base
 * on the bubble edge, thick through the middle, tip at the far corner. Fills
 * with `currentColor` so it matches the bubble.
 */
export function SpeechBubbleTail({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      className={className}
    >
      <path
        d="M0 0c0.4 8.6 6.4 16.4 22 20C11.6 20.6 3.6 18.4 0 14Z"
        fill="currentColor"
      />
    </svg>
  )
}
